import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/global';
import { Services } from "src/app/services/api.service"
import { getFingerprint as getOptIdFromList } from '@thumbmarkjs/thumbmarkjs'
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { ErrorMessageService } from 'src/app/services/error-message.util';

@Component({
  selector: 'app-voting-list',
  templateUrl: `${environment.pageFolder}/voting-list.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/voting-list.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule]
})
export class VotingListComponent {
  list: any;
  listIdOption: string = "";
  errorMessage: string = "";
  isVotingActive: any;
  firstOptionId: string = !environment.production ? "3531292596" : "3534298293";
  secondOptionId: string = !environment.production ? "3531292597": "3534298294";

  constructor(public Services: Services, private router: Router, private readonly errorMessageService: ErrorMessageService) {}

  ngOnInit(): void {
    const loader = document.getElementById("loader-container");

    if(!GlobalConstants.isAuth|| (sessionStorage.getItem("uploadedImage") !== "true")) { 
      this.router.navigate(['/izbori']);
    }
    
    this.Services.getListForVotingService().subscribe(Response => {
      this.list = Response.data.options;
      this.isVotingActive = Response.data.status;
      loader!.style.display = "none";
    })

    getOptIdFromList().then((data: string) => {
      this.listIdOption = this.getOptionId(data.toUpperCase());
    });
  }

  getOptionId(data: string) {
    const modulus = 37;
    const radix = 2;
    const characterSet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    let accumulator = 0;
    for (let i = 0; i < data.length; i++) {
      const characterValue = characterSet.indexOf(data.charAt(i));
      if (characterValue < 0) throw new Error("Unexpected character found: " + data.charAt(i));

      accumulator = ((accumulator + characterValue) * radix) % modulus;
    }

    const checksum = (modulus - accumulator + 1) % modulus;

    return data + characterSet.charAt(checksum);
  }

  submitSelectedList(selectedOption: string) {
    const loader = document.getElementById("loader-container");
    loader!.style.display = "flex";

    this.Services.submitSelectedListService(selectedOption, this.listIdOption).subscribe(Response => {        
      loader!.style.display = "none";
      
      if(Response.data === true) {
        sessionStorage.removeItem("uploadedImage");
        this.router.navigate(['/izbori/finish']);
        sessionStorage.setItem("votingDone9", "true"); 
      } else {
        this.errorMessage = this.errorMessageService.getErrorMessage("error");
      }
    }, (error: any) => {
      loader!.style.display = "none";
      this.errorMessage = this.errorMessageService.getErrorMessage("error");
    })
  } 

  returnToHomepage() {
    this.router.navigate(['/'])
  }
}